// Maps raw DB column names to Arabic labels for exports (PDF/CSV).
// Downloads are Arabic-by-default, so we translate column headers rather than
// showing the English snake_case keys.

export const PCU_NAME_AR = 'اتحاد المقاولين الفلسطينيين';
export const PCU_NAME_EN = 'Palestinian Contractors Union';

// Common column names across all entities -> Arabic.
const COLUMN_AR: Record<string, string> = {
  meeting_no: 'رقم الاجتماع',
  decisions_text: 'القرارات',
  attendees: 'الحضور',
  attendees_count: 'عدد الحضور',
  other_attendees: 'حضور آخرون',
  source_url: 'رابط المصدر',
  cover_image_url: 'صورة الغلاف',
  image_url: 'الصورة',
  thumb_url: 'الصورة المصغرة',
  album_id: 'الألبوم',
  album_name: 'الألبوم',
  album_cover_url: 'صورة الألبوم',
  photo_count: 'عدد الصور',
  photo_seq: 'ترتيب الصورة',
  file_url: 'الملف',
  filename: 'اسم الملف',
  meeting_id: 'الاجتماع',
  label: 'التسمية',
  url: 'الرابط',
  page: 'الصفحة',
  tabid: 'معرّف التبويب',
  content: 'المحتوى',
  phones: 'الهواتف',
  instructor_name: 'اسم المدرب',
  registration_deadline: 'آخر موعد للتسجيل',
  cost: 'التكلفة',
  location: 'الموقع',
  description: 'الوصف',
  font_family: 'الخط',
  orientation: 'اتجاه الصفحة',
  body_html: 'محتوى المستند',
  source_slide_id: 'معرّف المصدر',
  category: 'الفئة',
  file_path: 'مسار الملف',
  is_active: 'نشط',
  tags: 'الوسوم',
  time: 'الوقت',
  raw_datetime: 'التاريخ والوقت',
  id: 'المعرّف',
  pcu_id: 'رقم PCU',
  name: 'الاسم',
  title: 'العنوان',
  email: 'البريد الإلكتروني',
  mobile_number: 'رقم الجوال',
  landline_number: 'رقم الهاتف الأرضي',
  fax_number: 'رقم الفاكس',
  telephone_number: 'رقم التليفون',
  phone_number: 'رقم الهاتف',
  city: 'المدينة',
  city_id: 'المدينة',
  area: 'المنطقة',
  area_id: 'المنطقة',
  translation: 'الترجمة',
  header_text: 'نص الترويسة',
  footer_text: 'نص التذييل',
  logo_url: 'الشعار',
  primary_color: 'اللون الأساسي',
  is_default: 'افتراضي',
  classifications: 'التصنيفات',
  classification_expire_date: 'تاريخ انتهاء التصنيف',
  body: 'المحتوى',
  details: 'التفاصيل',
  date: 'التاريخ',
  start_date: 'تاريخ البدء',
  end_date: 'تاريخ الانتهاء',
  birth_date: 'تاريخ الميلاد',
  registration_date: 'تاريخ التسجيل',
  payment_date: 'تاريخ الدفع',
  created_at: 'تاريخ الإنشاء',
  updated_at: 'تاريخ التحديث',
  // companies / partners
  company: 'الشركة',
  company_id: 'الشركة',
  partner: 'الشريك',
  partner_id: 'الشريك',
  payments: 'المدفوعات',
  // tenders
  tender_name: 'اسم العطاء',
  owner_name: 'اسم المالك',
  financier_name: 'اسم الممول',
  funder_name: 'اسم الممول',
  type: 'النوع',
  status: 'الحالة',
  currency: 'العملة',
  insurance_value: 'قيمة التأمين',
  attachment: 'المرفق',
  link: 'الرابط',
  // tenders: scraper-added columns
  reference_no: 'الرقم المرجعي',
  authority_dept: 'الجهة / الدائرة',
  tender_kind: 'نوع الأشغال',
  docs_price: 'ثمن المستندات',
  docs_currency: 'عملة المستندات',
  docs_available_from: 'استلام المستندات من',
  site_visit: 'الزيارة الميدانية',
  inquiries_deadline: 'آخر موعد للاستفسارات',
  submission_deadline: 'آخر موعد لتقديم العطاء',
  submission_time: 'وقت التقديم',
  opening_datetime: 'موعد فتح المظاريف',
  bid_validity_days: 'مدة سريان العطاء (أيام)',
  contact_fax: 'الفاكس',
  website: 'الموقع الإلكتروني',
  submission_address: 'عنوان تقديم العطاء',
  source: 'المصدر',
  source_key: 'مفتاح المصدر',
  source_bulletin_date: 'تاريخ النشرة',
  source_bulletin_dates: 'تواريخ النشرة',
  is_public: 'منشور للعامة',
  needs_review: 'بحاجة لمراجعة',
  ocr_notes: 'ملاحظات المسح الضوئي',
  dedupe_key: 'مفتاح التكرار',
  data_notes: 'ملاحظات البيانات',
  // trainings: scraper-added columns
  cost_currency: 'عملة التكلفة',
  flyer_url: 'الإعلان (صورة)',
  announced_date: 'تاريخ الإعلان',
  // news / gallery: source photo tracking
  cover_source_photo_url: 'صورة المصدر (الغلاف)',
  source_photo_url: 'صورة المصدر',
  source_index: 'الترتيب',
  // tender_attachments
  bulletin_date: 'تاريخ النشرة',
  seq: 'الترتيب',
  width: 'العرض',
  height: 'الارتفاع',
  // contracts
  value: 'القيمة',
  contractors: 'المقاولون',
  contractor_id: 'المقاول',
  tender_id: 'العطاء',
  // fund_system
  subscription_number: 'رقم الاشتراك',
  meeting_sub_number: 'رقم فرعي للاجتماع',
  sub_year: 'سنة الاشتراك',
  fund_amount: 'مبلغ الصندوق',
  subscription_fees: 'رسوم الاشتراك',
  id_card: 'بطاقة الهوية',
  fees_paid_bool: 'تم دفع الرسوم',
  payment_status: 'حالة الدفع',
  // messages / news / events
  to_recipient: 'المستلم',
  to_recipients: 'المستلمون',
  is_read: 'مقروءة',
  sender_id: 'المرسل',
  cities: 'المدن',
  internal_id: 'الرقم الداخلي',
  delivery_method: 'طريقة التسليم',
  created_by: 'أنشئ بواسطة',
  file: 'الملف',
  authorized_person: 'الشخص المخوّل',
  is_admin: 'مدير',
  // classifications
  field: 'المجال',
  specialization: 'التخصص',
  // aggregates (count/total queries)
  total: 'الإجمالي',
  count: 'العدد',
  cnt: 'العدد',
  number: 'العدد',
  average: 'المتوسط',
  avg: 'المتوسط',
  sum: 'المجموع',
  // joined location names
  city_name: 'المدينة',
  city_code: 'رمز المدينة',
  city_translation: 'المدينة',
  area_name: 'المنطقة',
  area_code: 'رمز المنطقة',
  area_translation: 'المنطقة',
  // documents
  file_name: 'اسم الملف',
  file_size: 'حجم الملف',
  mime_type: 'نوع الملف',
  download_count: 'مرات التحميل',
  published_date: 'تاريخ النشر',
};

// Entity table name -> Arabic label (for the report title).
export const ENTITY_AR: Record<string, string> = {
  gallery_photos: 'صور المعرض',
  photo_albums: 'ألبومات الصور',
  board_meetings: 'اجتماعات مجلس الإدارة',
  board_attachments: 'مرفقات الاجتماعات',
  branches: 'الفروع',
  related_links: 'روابط ذات صلة',
  info_pages: 'صفحات تعريفية',
  trainings: 'التدريبات',
  documents: 'المستندات',
  document_templates: 'قوالب المستندات',
  companies: 'الشركات',
  partners: 'الشركاء',
  classifications: 'التصنيفات',
  contracts: 'العقود',
  tenders: 'العطاءات',
  tender_attachments: 'مرفقات العطاءات',
  events: 'الفعاليات',
  messages: 'الرسائل',
  news: 'الأخبار',
  outward_letters: 'الصادر',
  files: 'الملفات',
  fund_system: 'صندوق التكافل',
  areas: 'المناطق',
  cities: 'المدن',
  profiles: 'المستخدمون',
};

const titleCase = (key: string) =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

/** Arabic header for a DB column; falls back to a tidied version of the key. */
export const arabicColumnLabel = (key: string): string => COLUMN_AR[key] || titleCase(key);

/** Arabic label for an entity/table name; falls back to a tidied version. */
export const arabicEntityLabel = (entity: string | null | undefined): string =>
  (entity && ENTITY_AR[entity]) || (entity ? titleCase(entity) : 'النتائج');
